/**
 * @file: 首页推荐视频瀑布流
 * @author: zhangjie13
 */
import React, { useEffect, useState, useRef } from 'react';
import * as services from '@services/index';
import shuffle from 'lodash/shuffle';
import InfiniteScroll from 'react-infinite-scroll-component';
import NoMoreBottom from '@components/NoMoreBottom';
import Loading from '@/components/Loading';
import RecommendVideoCard from '../../components/RecommendVideoCard';

import styles from './index.module.scss';

const RecommendList = () => {
  const [videoList, setVideoList] = useState([] as any);
  const [isLast, setIsLast] = useState(true);
  const [loadMoreLoading, setLoadMoreLoading] = useState(false);
  const pageObj = useRef({
    pageNum: Number(localStorage.getItem('health_hot_page')) || 1,
    pageSize: 10
  });

  useEffect(() => {
    Promise.resolve().then(() => getInitSeries());
  }, []);

  const getInitSeries = async () => {
    try {
      const res: any = await services.videos.getHomeHotVideos({
        ...pageObj.current
      });
      const { list = [], pageNum, pageSize, lastMark } = res;
      const shuffleList = shuffle(list);
      pageObj.current = {
        pageNum,
        pageSize
      };
      setIsLast(lastMark);
      setVideoList(shuffleList);
    } catch (error) {
      //
    }
  };

  const loadMoreSeries = async () => {
    if (loadMoreLoading && !pageObj.current && isLast) {
      return;
    }
    setLoadMoreLoading(true);
    const res = await services.videos.getHomeHotVideos({
      pageNum: pageObj.current.pageNum + 1,
      pageSize: pageObj.current.pageSize
    });
    const { list = [], pageNum, pageSize, lastMark } = res;
    const shuffleList = shuffle(list);
    pageObj.current = {
      pageNum,
      pageSize
    };
    localStorage.setItem('health_hot_page', pageNum);
    const newList = videoList.concat(shuffleList);
    setLoadMoreLoading(false);
    setIsLast(lastMark);
    setVideoList(newList);
  };

  return (
    <ul className={styles['recommend-list']}>
      {!!videoList.length && (
        <InfiniteScroll
          dataLength={videoList.length}
          next={loadMoreSeries}
          hasMore={!isLast}
          loader={<Loading type="small" />}
          endMessage={<NoMoreBottom />}
        >
          {videoList.map(
            (video: any, index) =>
              !!video && (
                <RecommendVideoCard
                  key={`${video.albumId}-${index}`}
                  video={video}
                  videoIndex={index + 1}
                />
              )
          )}
        </InfiniteScroll>
      )}
    </ul>
  );
};

export default RecommendList;
